import { t } from '@lingui/macro';
import { Button, Group } from '@economic/taco';
import React, { useState } from 'react';
import * as Yup from 'yup';
import { Field, Form } from '../../../shared/components/Form';

import * as types from '../../../../types/internal-api';
import { useLocalization } from '../../../shared/components/l10n/l10n';
import { ArrowKeyNavigationProps } from '../../../shared/components/Form/BaseFormWithArrowKeyNavigation';

const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    id: Yup.number().required(),
});

interface Props
    extends Pick<ArrowKeyNavigationProps, 'idKeyProp' | 'collectionData' | 'currentItemId' | 'onArrowKeySaveAndChange'> {
    initialValue: Partial<types.ProductCollectionModel>;
    onCreate: (values: types.ProductCollectionModel, isSaveAndNew: boolean) => Promise<any>;
    showSaveAndNewButton?: boolean;
    disableId?: boolean;
}

export default function ProductCollectionForm({
    initialValue,
    disableId,
    showSaveAndNewButton,
    onCreate,
    ...arrowKeyNavigationProps
}: Props) {
    useLocalization(textIds);
    const [saveAndNew, setSaveAndNew] = useState(false);
    const [requestPending, setRequestPending] = useState<boolean>(false);

    async function handleSubmit(values: types.ProductCollectionModel) {
        setRequestPending(true);
        try {
            const response = onCreate(values, saveAndNew);
            return Promise.resolve(response);
        } catch (error) {
            error.validation = error.response.data;
            return Promise.reject(error);
        }
    }

    function onSubmitError() {
        setRequestPending(false);
    }

    function handleSubmitted() {
        setSaveAndNew(false);
        setRequestPending(false);
    }

    return (
        <Form
            validateOnBlur={false}
            {...arrowKeyNavigationProps}
            onSubmit={handleSubmit}
            onSubmitted={handleSubmitted}
            onSubmitError={onSubmitError}
            validationSchema={validationSchema}
            initialData={initialValue}>
            <Field.Number name="id" label={t`No.`} required disabled={disableId} />
            <Field.Text name="name" label={t`Name`} required />

            <Group className="form__buttons" style={{ display: 'flex' }}>
                {showSaveAndNewButton && (
                    <Button
                        appearance="primary"
                        className="p-0"
                        disabled={requestPending}
                        type="submit"
                        autoFocus
                        onClick={() => {
                            setSaveAndNew(true);
                        }}>
                        {t`Save and new`}
                    </Button>
                )}

                <Button
                    appearance={showSaveAndNewButton ? 'default' : 'primary'}
                    className="p-0"
                    disabled={requestPending}
                    type="submit"
                    autoFocus>
                    {t`Save`}
                </Button>
            </Group>
        </Form>
    );
}
const textIds = ['ERROR_CODE_ProductCollectionAlreadyExists'];
